import { render, staticRenderFns } from "./CustomLoading.vue?vue&type=template&id=6812a22d"
import script from "./CustomLoading.vue?vue&type=script&lang=js"
export * from "./CustomLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports